import { useState } from "react";
import { createContext } from "react";
export const CartContext = createContext()

const CartProvider = (props) => {
    const [cart, setCart] = useState([])
    const [added, setAdded] = useState(false)
    const [clicked,setClicked] = useState(false)
    const [formData, setFormData] = useState({
        fullName:'',
        email:'',
        number:'',
        address:'',
      })
    const addToCart = (title, image, productId, price) => {
        const exist = cart.find(item => item.productId === productId)
        // if exist
        if(exist){
            // increase the quantity by one
            let newResults = cart.map(item => {
                return(
                    item.productId === productId ? {...item , qty : Number(item.qty) + 1} : item
                )
            })
            setCart(newResults)
            localStorage.setItem('cart', JSON.stringify(newResults))
        }
        else{
            let newEntry = {title, image, productId, price, qty:1}
            let newResults = [...cart, newEntry]
            setCart(newResults)
            localStorage.setItem('cart', JSON.stringify(newResults))
        }
        setAdded(true)
        setTimeout(()=>{
            setAdded(false)
        }, 1000)
    }
    const removeItem = (productId) => {
        const newResults = cart.filter(item => item.productId !== productId)
        setCart(newResults)
        localStorage.setItem('cart', JSON.stringify(newResults))
    }

    const updateQty = (productId, qty) => {
        const item = cart.find(item => item.productId === productId)
        if(item){
            console.log(qty, Number(qty) !== 0)
            if(Number(qty) !== 0){
                item.qty = qty
                const newResult = cart.map(product => product.productId === productId ? item : product)
                setCart(newResult)
                localStorage.setItem('cart', JSON.stringify(newResult))
            }else{
                const newResults = cart.filter(item => item.productId !== productId)
                setCart(newResults)
                localStorage.setItem('cart', JSON.stringify(newResults))
            }
        }
    }
    return(
        <CartContext.Provider
        value={{
            addToCart,
            removeItem,
            cart,setCart,
            formData, setFormData,
            clicked,setClicked,
            updateQty,
            added
        }}>
            {props.children}
        </CartContext.Provider>
    )
}

export default CartProvider